import { stockRepo } from '../repo/stockRepo';

export const stockService = {
    async getAll(params = {}) {
        try {
            const response = await stockRepo.getAll(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getMyShops(params = {}) {
        try {
            const response = await stockRepo.getMyShops(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(stockId) {
        if (!stockId) {
            throw new Error('Stock ID is required');
        }
        try {
            const response = await stockRepo.getById(stockId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByShop(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await stockRepo.getByShop(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getAvailableForSale(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            return await stockRepo.getAvailableForSale(shopId);
        } catch (error) {
            throw this.handleError(error);
        }
    },
    async getMyShopsAvailableForSale() {
    try {
        const response = await stockRepo.getMyShopsAvailableForSale();
        return response;
    } catch (error) {
        throw this.handleError(error);
    }
},

    async getTotalByShop(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await stockRepo.getTotalByShop(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByDateRange(params = {}) {
        if (!params.start_date || !params.end_date) {
            throw new Error('Start date and end date are required');
        }
        try {
            const response = await stockRepo.getByDateRange(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getWithSales(stockId) {
        if (!stockId) {
            throw new Error('Stock ID is required');
        }
        try {
            const response = await stockRepo.getWithSales(stockId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async create(data) {
        if (!data.shopId) {
            throw new Error('Shop ID is required');
        }
        if (!data.productId) {
            throw new Error('Product ID is required');
        }
        if (!data.dozen_amount || data.dozen_amount < 0) {
            throw new Error('Valid dozen amount is required');
        }
        if (!data.purchase_price || data.purchase_price < 0) {
            throw new Error('Valid purchase price is required');
        }
        if (!data.selling_price || data.selling_price < 0) {
            throw new Error('Valid selling price is required');
        }
        if (!data.purchase_date) {
            throw new Error('Purchase date is required');
        }

        try {
            const response = await stockRepo.create(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async update(stockId, data) {
        if (!stockId) {
            throw new Error('Stock ID is required');
        }

        try {
            const response = await stockRepo.update(stockId, data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleStatus(stockId) {
        if (!stockId) {
            throw new Error('Stock ID is required');
        }

        try {
            const response = await stockRepo.toggleStatus(stockId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats() {
        try {
            const response = await stockRepo.getAll({ per_page: 1000 });
            const stocks = response.data?.data || [];
            return {
                total: stocks.length,
                total_dozen: stocks.reduce((sum, s) => sum + parseInt(s.dozen_amount || 0), 0),
                total_investment: stocks.reduce((sum, s) => sum + parseFloat(s.purchase_price || 0), 0),
                total_potential_revenue: stocks.reduce((sum, s) => sum + parseFloat(s.selling_price || 0), 0),
                active: stocks.filter(s => s.status === 'active').length,
                inactive: stocks.filter(s => s.status === 'inactive').length,
            };
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('StockService Error:', error);
        return error.response?.data || error;
    }
};
